<div class="app-manager">
  <!-- Header -->
  <div class="app-manager-header">
    <div class="header-content">
      <div class="header-left">
        <h1>My Apps</h1>
        <p class="subtitle">Manage your personal app collection</p>
      </div>
      <div class="header-actions">
        <button 
          class="refresh-btn" 
          (click)="refreshApps()" 
          [disabled]="isLoading"
          title="Refresh apps">
          <span class="icon">↻</span>
          Refresh
        </button>
        <button 
          class="add-apps-btn" 
          (click)="toggleSidebar()"
          [class.active]="isSidebarOpen">
          <span class="icon">+</span>
          Add Apps
        </button>
      </div>
    </div>
  </div>

  <!-- Error Message -->
  <div *ngIf="error" class="error-banner">
    <div class="error-content">
      <span class="error-icon">⚠</span>
      <span>{{ error }}</span>
      <button class="error-close" (click)="clearError()" aria-label="Close error">×</button>
    </div>
  </div>

  <!-- Main Content Area -->
  <div class="app-manager-body" [class.sidebar-open]="isSidebarOpen">
    
    <!-- Main Content -->
    <div class="main-content">
      
      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-container">
        <div class="loading-spinner"></div>
        <p>Loading your apps...</p>
      </div>

      <!-- Empty State -->
      <div *ngIf="!isLoading && userApps.length === 0" class="empty-state">
        <div class="empty-content">
          <div class="empty-icon">📱</div>
          <h2>No apps yet</h2>
          <p>Start building your personal app collection by adding some apps from the sidebar.</p>
          <button class="empty-action-btn" (click)="toggleSidebar()">
            <span class="icon">+</span>
            Add Your First App
          </button>
        </div>
      </div>

      <!-- Apps Grid -->
      <div *ngIf="!isLoading && userApps.length > 0" class="apps-content">
        <div class="apps-header">
          <h2>Your Apps <span class="app-count">({{ userApps.length }})</span></h2>
          <div class="view-options">
            <!-- Future: Add grid/list view toggle -->
          </div>
        </div>

        <div class="apps-grid">
          <div *ngFor="let app of userApps" class="app-card">
            <div class="app-card-content">
              
              <!-- App Icon -->
              <div class="app-icon-container">
                <img 
                  *ngIf="app.icon" 
                  [src]="app.icon" 
                  [alt]="app.name + ' icon'"
                  class="app-icon"
                  (error)="onImageError($event)">
                <div *ngIf="!app.icon" class="app-icon-placeholder">
                  {{ app.name.charAt(0).toUpperCase() }}
                </div>
              </div>

              <!-- App Info -->
              <div class="app-info">
                <h3 class="app-name">{{ app.name }}</h3>
                <p class="app-category">{{ app.category }}</p>
                <p class="app-added-date">Added {{ app.addedAt | date:'shortDate' }}</p>
              </div>

              <!-- App Actions -->
              <div class="app-actions">
                <button 
                  class="action-btn open-btn" 
                  (click)="openApp(app)"
                  title="Open app">
                  <span class="icon">🚀</span>
                  Open
                </button>
                <button 
                  class="action-btn remove-btn" 
                  (click)="removeApp(app)"
                  title="Remove from my apps">
                  <span class="icon">🗑</span>
                  Remove
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Sidebar -->
    <div class="sidebar-container" [class.open]="isSidebarOpen">
      <app-app-selector-sidebar></app-app-selector-sidebar>
    </div>
  </div>

  <!-- Sidebar Backdrop for Mobile -->
  <div 
    *ngIf="isSidebarOpen" 
    class="sidebar-backdrop"
    (click)="toggleSidebar()">
  </div>
</div>
